import { NotificationBlockProps } from '@anm/components/NotificationBlock';

import { NotificationElement } from '.';
import { NotificationState } from './types';

type CreateNotificationParams = NotificationState & NotificationBlockProps;

const deleteNotification = (
  currentId: number,
  notifications: NotificationElement[],
  setNotifications: (arr: NotificationElement[]) => void
) => {
  const newNotifications = notifications.filter(({ id }) => id !== currentId);
  setNotifications(newNotifications);
};

export const createNotification = ({
  notifications,
  setNotifications,
  ...notificationProps
}: CreateNotificationParams): NotificationElement => ({
  ...notificationProps,
  id: Date.now(),
  deleteNotification: (id: number) => {
    deleteNotification(id, notifications, setNotifications);
  }
});
